import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { MediaAssetRowEntry } from "frontend/contentful/schema/blocks";
import { MediaAssetRowProps } from "design-system/components/blocks/media-asset-row/media-asset-row";
import { createComponentHeaderProps } from "../primitives/component-header.props";
import { RenderContentfulRichText } from "../utils/render-contentful-rich-text";
import { createRichMediaAssetProps } from "../primitives/media-asset.props";
import { MediaAssetRowOptions } from "./media-asset-row.contentful";

export const createMediaAssetRowProps = createContentfulProps<
  MediaAssetRowEntry,
  MediaAssetRowProps,
  MediaAssetRowOptions
>(({ entry, options, createEditAttributes }) => {
  const headerAbove = options?.headerAbove || false;

  const props: MediaAssetRowProps = {
    assets: [],
    align: entry.fields.alignment!,
    header: createComponentHeaderProps(entry.fields.header),
    HeadingLevel: headerAbove ? "h3" : "h2",
    caption: <RenderContentfulRichText document={entry.fields.caption} />,
    isVerticalImages: entry.fields.isVerticalImages,
    editAttributes: {
      caption: createEditAttributes({ entry, fieldId: "caption" }),
    },
  };

  entry.fields.media?.forEach((media) => {
    const assetProps = createRichMediaAssetProps(media);
    if (assetProps) {
      // disable alignment for the row
      if (assetProps.image) assetProps.image.align = undefined;

      props.assets?.push(assetProps);
    }
  });

  return props;
});
